import Head from 'next/head'
import Layout from '../components/Layout'
import useAuth, {  updateUserDetails, updateUserDetails2 } from '../lib/useAuth'
import styles from './account-information.module.scss'

import Link from 'next/link'
import { LoadingOverlay, Modal, Paper, Text, TextInput, Button, PasswordInput, FocusTrap, Grid, Stack, NavLink, Box, Divider, Center, Table, Radio, Textarea, PinInput } from '@mantine/core';
import AuthContent from '../components/AuthContent'
import { MenuId } from '../components/Header'
import { createRef, useEffect, useState } from 'react'
import { consoleError } from '../lib/logger'

import { CheckoutInformation, Payment, PaymentInformation, PaymentUpdateShoppingCartItem, ProcessorType, ShoppingCartItemType, SubscriberLevel, SubscriptionStatus, WPError } from '../lib/definitions'

import { useRouter } from 'next/router'
import AccountDescription from '../components/AccountDescription'
import { useForm } from '@mantine/form'
import { getGBPPriceForSubscription, okModal } from '../lib/utils'

import { DateTime } from 'luxon'
import { currencyCode, localPrice } from '../components/Localization'
import { useRawUmberContext } from '../lib/rawumberprovider'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/pro-duotone-svg-icons'
import { PinturaEditor } from '@pqina/react-pintura'
import { ImageUpload, ImageUploadHandle, ImageUploadedProps } from '../components/ImageUpload'
import { GetServerSideProps } from 'next'

import { getAuth, buildClerkProps } from '@clerk/nextjs/server';
import { useUser } from '@clerk/nextjs'
import type { EmailAddressResource, UserResource } from '@clerk/types';
import { modals } from '@mantine/modals';
import { useReverification } from '@clerk/nextjs';
import { ClerkAPIError, ClerkAPIResponseError } from '@clerk/types';

import { ok } from 'assert'


export default function MyAccount() {

    const {userInformation} = useAuth();

    const [working, setWorking] = useState(false);
    const {refreshUserInformation} = useAuth();
    const [payments, setPayments] = useState<Payment [] | null>();
    const [paymentInformation, setPaymentInformation] = useState<PaymentInformation | null>(null);
    
    const [canIUpgrade, setCanIUpgrade] = useState<boolean | null>(null);
    const { localizationInformation, currencies} = useRawUmberContext();
    const [upgraded, setUpgraded] = useState(false);
    const router = useRouter();
    const [subscriptionCancelled, setSubscriptionCancelled] = useState(false);
    const [avatarGuid, setAvatarGuid] = useState('');
    const uploadRef = createRef<ImageUploadHandle>();
    
    const createEmailAddress = useReverification(async (email: string) => 
      {
        //console.log("Creating email address for", email); 
        const e = await user?.createEmailAddress({ email });
        return e;

});

const verifyEmailAddress = useReverification(async (emailAddressId: string) => {
  //console.log("Verifying email address with id", emailAddressId);
  const emailAddress = user?.emailAddresses.find(e => e.id === emailAddressId);
  await emailAddress?.prepareVerification({strategy: 'email_code'});

});

  const attachEmailAddress=useReverification(async (emailAddressId: string) => {

    await user?.update({ primaryEmailAddressId: emailAddressId });
  });

  const updatePassword=useReverification(async (password: string) => {

    await user?.updatePassword({ newPassword: password});
  });


     const triggerReverification = useReverification(async () => {});


    const { user } = useUser()  as { user: UserResource | null | undefined; isLoaded: boolean; isSignedIn: boolean | undefined };


    
    enum MenuItems
      {
        logonInformation = "Log on information",
        avatar="Upload profile picture",
        paymentHistory = "Payment history",
        upgradeAccount = "Upgrade account",
        changePaymentMethod = "Change credit card",
        cancelAccount = "Cancel account",
        //linkToInstagram="Link to Instagram",
        logOut = "Log out"

      }
    
    const [activeMenu, setActiveMenu] = useState(MenuItems.logonInformation);

    const detailsForm = useForm({
        initialValues: {userName:userInformation?.userName??'', email: userInformation?.email??'', firstName: userInformation?.firstName??'',lastName: userInformation?.lastName??'', password:'', password2:'' },
         validate: {
            userName: (value) => (value.trim().length<3)?'Your user name needs to be at least 2 characters long':null,
          email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
          password: (value) => (value.trim().length!=0 && value.trim().length<6)?"Please use a password that's at least 7 characters long":null,
          password2: (value, values) => (value!=values.password)?"The passwords don't match":null

        },
      });

      const cancellationForm=useForm({
        initialValues:{cancellationReason:''}
      })

      const upgradeForm = useForm({
        initialValues: {
          upgradeOption: '',
        },
        validate:
        {
          upgradeOption: (value)=>value.length==0?"Please choose an option": null
        }

    });

    
/*
      useEffect(()=>
      {

        if (userInformation)
        {
          console.log("Setting form values to", userInformation);
            detailsForm.values.email = userInformation?.email??'';
            detailsForm.values.firstName = userInformation?.firstName??'';   
            detailsForm.values.userName = userInformation?.userName??'';  
            fetchAvatar();
        }

      }, [userInformation]);*/

      async function submit(values: typeof detailsForm.values)
      {
          await innerUpdateUserDetails();

      }

      function uploadAvatar()
      {
        if (uploadRef.current)
        {
          uploadRef.current.show();
        }        
      }

      function avatarUploaded(props: ImageUploadedProps)
      {
        setAvatarGuid(props.data.guid);
      }

        async function showVerificationModal(emailAddress: EmailAddressResource): Promise<void>
        {
          let resolved = false;

          return new Promise<void>((resolve, reject) => {
            const id=modals.open({
              title: 'Verify your email',
              onClose: () => {if (!resolved) {
                
                reject()};},
              children: (
                <EmailCodeForm
                  email={detailsForm.values.email}
                 
                  onSubmit={async (code) => {
                    try {
                      await emailAddress?.attemptVerification({ code });
                      await attachEmailAddress(emailAddress.id);
                      await updateUserDetails2(undefined, undefined, undefined, detailsForm.values.email);
                              resolved= true;
                      modals.close(id);
                      refreshUserInformation();
              
                      resolve();
                    }
                    catch (err: any) {
                        const ec = (err as unknown as ClerkAPIResponseError).errors?.[0]?.code;
                        if (ec=='form_code_incorrect')
                        {
                          await okModal("The code you entered is incorrect. Please check your email and try again.");
                        }
                        else
                          {
                              console.error(err);
                              await okModal("There was a problem changing your email address");
                          }
                      // re-open or show inline error
                    }
                  }}
                />
              )
            });
          });
        }

      async function changePassword()
      {

        try
        {
          await updatePassword(detailsForm.values.password);
        }
        catch (error)
        {
          console.log("Error changing password", error);
          const ec = (error as unknown as ClerkAPIResponseError).errors?.[0]?.code;
          console.log(ec);
          throw error;
        }


      }

      async function changeEmailAddress()
      {
        
            const newEmail =  detailsForm.values.email;

            const existingEmail = user?.emailAddresses.find(e => e.emailAddress.toLowerCase() === newEmail.toLowerCase());

            const emailAlreadyExists = !!existingEmail;
            let emailAddress : EmailAddressResource | undefined;

            if (!emailAlreadyExists)
            {
              //two step process to change email

              emailAddress = await createEmailAddress(detailsForm.values.email);
              if (!emailAddress)
              {
                throw new WPError("There was a problem changing your email address. Please try again later.");
              }                  
            }
            else
            {
              emailAddress = existingEmail;
            }
                
          if (!emailAlreadyExists || (existingEmail && existingEmail.verification?.status !== 'verified'))
          {
          
            //need to verify the email address

            await verifyEmailAddress(emailAddress.id);
            await showVerificationModal(emailAddress);               
          }
        }
  
      async function innerUpdateUserDetails()
      {
            setWorking(true);

            try
            {
                await updateUserDetails2( detailsForm.values.userName, detailsForm.values.firstName, detailsForm.values.lastName);
                /*await logIn( detailsForm.values.email,
                         detailsForm.values.password.length!=0?detailsForm.values.password:values.password,
                        false);*/

              const newEmail =  detailsForm.values.email;
              
              //console.log(newEmail, userInformation?.email);

              if (newEmail!=userInformation?.email || (detailsForm.values.password.length!=0))
              {
                  await triggerReverification();
              }

              if (newEmail!=userInformation?.email)
              {
                 await changeEmailAddress();
              }

              if (detailsForm.values.password.length!=0)
              {
                await changePassword();
              }
        
              okModal("Your details were successfully updated!");                    
             
            }
            catch (e)
            {
                if (e instanceof WPError)
                {
                    okModal(e.message);
                }
                else
                {
                    consoleError(e);

                      const m = ((e as unknown as ClerkAPIResponseError).errors?.[0]?.message)??"There was a problem updating your details. Please try again later";
                      okModal(m);
                }
            }
            finally

            {

              refreshUserInformation();
              setWorking(false);
            }

            
      }
      

      async function submitUpgrade(values: typeof upgradeForm.values)
      {
          setWorking(true);
          try
          {
            if (!await upgradeMe())
            {
              //when redirecting to PayPal, don't need to stop the spinner
              setWorking(false);
            }
          }
          catch
          {
            setWorking(false);
            okModal("There was a problem upgrading you. Please contact us at info@rawumberstudios.com and we can help you out");
          }

         // setWorking(false);
      }

      async function submitCancellation(values: typeof cancellationForm.values)
      {
          setWorking(true);
          try
          {
            await cancelMe();
            setSubscriptionCancelled(true);
            refreshUserInformation();

          }
          catch
          {
            okModal("There was a problem cancelling your subscription. Please contact us at info@rawumberstudios.com and we can help you out");
          }

         setWorking(false);
      }

      function cancelAccount()
      {
        setActiveMenu(MenuItems.cancelAccount);  
      }

      function upgradeAccount()
      {
        setActiveMenu(MenuItems.upgradeAccount);
      }
      
      function refresh()
      {
          window.location.reload();
      }

      async function changePaymentMethod(e: React.MouseEvent<HTMLElement>)
      {
        e.preventDefault();
        setWorking(true);

        let s : PaymentUpdateShoppingCartItem = 
        {
          itemType: ShoppingCartItemType.paymentUpdate,
          firstName: userInformation?.firstName,
          
          data: {}
        }

        let cancelUrl = window.location.href;
        
        try
        {
        let at =  await fetch('/n/api/getstripecheckoutsession', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({cartItem: s, cancelUrl: cancelUrl }),
              credentials:"include"

          });   

          let ret  : CheckoutInformation= await at.json();

          window.location.href = ret.url;
      }
      catch
      {
        okModal("There was a problem updating your card details. Please email us at info@rawumberstudios.com instead.");
        setWorking(false);
      }
      }

      let panel=<></>

      const passwordEnabled =true;

      switch (activeMenu)
      {
        case MenuItems.logonInformation:
          panel=<>
          <FocusTrap active>
          <form onSubmit={detailsForm.onSubmit( async (values)=> await submit(values))}>                            
              <TextInput label="User name" type="text" required {...detailsForm.getInputProps('userName')} data-autofocus/>
              <TextInput label="First name" type="text" required {...detailsForm.getInputProps('firstName')}/>
              <TextInput label="Last name" type="text" required {...detailsForm.getInputProps('lastName')}/>
              <TextInput label="Email address" type="email" required {...detailsForm.getInputProps('email')}/>

              {passwordEnabled && <>
              <PasswordInput data-sentry-mask label="New password"  {...detailsForm.getInputProps('password')}/>
              <PasswordInput data-sentry-mask label="Confirm new password" {...detailsForm.getInputProps('password2')}/>
              </>}  
              <Button type='submit' mt='sm'>Submit</Button>
                             
            </form>            
            </FocusTrap>
                   </>
                   break;
        case MenuItems.paymentHistory:
          if (!payments)
          {
            panel=<></>
          }
          else
          {
          panel=<>
          <Table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {payments && payments.map((x)=><tr key={x.dateTransacted}><td>{DateTime.fromISO(x.dateTransacted).toFormat('dd LLL yyyy')}</td><td>{currencyCode(x.currency)}{x.amount.toFixed(2)}</td></tr>)}
            </tbody>
          </Table>
          </>
          }
          break;
        case MenuItems.upgradeAccount:

        if (upgraded)
        {
          panel = <>Thank you for upgrading! Your new subscription will be activated in a minute or two - please wait for your confirmation email and <a href='#' onClick={refresh}>refresh</a> this page.</>
        }
        else
        {

          const contactUs = <Text>Please <a href='mailto@rawumberstudios.com'>contact us</a> to upgrade your subscription.</Text>;

          if (canIUpgrade==null)
          {
            panel=<></>
          }
          else if (!canIUpgrade)
          {
            panel=contactUs;
          }
          else
          {
            panel=<>
            <form onSubmit={upgradeForm.onSubmit(async (values)=>await submitUpgrade(values))}>
              <Text>If you change your subscription then you will be upgraded automatically. You will then be charged / refunded at the next billing cycle for any difference, and then billed monthly at the new rate. To see more information about the different levels of subscription, go <Link href='/subscription'>here</Link>.</Text>                
               <Radio.Group mt='lg'
      name="length"
      label="Please choose one of the following options:"
      withAsterisk
      required
      {...upgradeForm.getInputProps('upgradeOption')}
    >
      <Stack>
      {userInformation?.subscriber_level!=SubscriberLevel.image && <Radio value={SubscriberLevel.image} label={"Image subscription @ " + localPrice(getGBPPriceForSubscription(SubscriberLevel.image), localizationInformation, currencies) }/>}

      {/* userInformation?.subscriber_level!=SubscriberLevel.standard && <Radio value={SubscriberLevel.standard} label={"Standard subscription @ " +localPrice(getGBPPriceForSubscription(SubscriberLevel.standard), localizationInformation, currencies) } />*/}
      {userInformation?.subscriber_level!=SubscriberLevel.gold && <Radio value={SubscriberLevel.gold} label={"Gold subscription @ " + localPrice(getGBPPriceForSubscription(SubscriberLevel.gold), localizationInformation, currencies) }/>}
      </Stack>
    </Radio.Group>
    <Button type='submit' mt='sm'>Submit</Button>
    </form>
            </>
          }
        }
          break;

          case MenuItems.cancelAccount:

          if (subscriptionCancelled)
          {
            panel=<Text>We have successfully cancelled your subscription. You can still access your subscription until the renewal date. Thank you again for supporting us!</Text>
          }
          else
          {
            if (!userInformation?.subscribed)
            {
              panel = <Text>You do not currently have a subscription</Text>
            }
            else if (userInformation.status == SubscriptionStatus.pendingCancellation)
            {
              panel = <Text>You have already cancelled your subscription.</Text>
            }
            else if (userInformation.is_fixed_term)
            {
              panel = <Text>Your subscription is fixed term, so you cannot cancel.</Text>
            }
            else
            {
              panel=<>
              <Text mb="lg">Are you really sure you want to cancel your account? If so, we&rsquo;d appreciate if you could let us know why so we can do better next time. This is completely optional though!</Text>
              <form onSubmit={cancellationForm.onSubmit( (values)=> submitCancellation(values))}>
              <Textarea
          placeholder="In a few words, please let us know why you want to cancel. This is optional!"
          label=""
          autosize
          minRows={2}
          {...cancellationForm.getInputProps('cancellationReason')}/>

  <Button type='submit' mt='sm'>I am sure I want to cancel!</Button>
                </form>    
              </>
            }
          } 

          break;

          /*case MenuItems.linkToInstagram:
            panel=<Text>Want to pull in your work from Instagram to show in our <Link href='/user-images'>gallery</Link>? Click <Link href='/instagram/authorize'>here</Link></Text>
            break;*/

          case MenuItems.logOut:
            panel=<Text>Click <Link href='/log-out'>here</Link> to log out of your account</Text>
            break;
          case MenuItems.avatar:
            let avatarImg = <></>
            let style : React.CSSProperties ={width:"100%", height:"100%"}
            if (avatarGuid)
            {
              avatarImg=<img style={style} src={`https://user-images.rawumberstudios.com/avatar_${avatarGuid}_240.jpg`}/>
            }
            else
            {
              avatarImg=<FontAwesomeIcon style={style as any} icon={faUser}/>
            }
            panel=<>
            <Text>This will be used in the livestream chat, and on the <Link href='/user-images'>gallery</Link></Text>
            <div style={{display:"flex", flexDirection:"column", maxWidth:200}}>
            <div style={{height:170, width:170, margin:10, borderRadius:"50%", overflow:"hidden"}}>{avatarImg}</div>
            <Button onClick={()=>uploadAvatar()}>Change</Button>
            </div>
            </>
            break;
          case MenuItems.changePaymentMethod:
            panel=<></>

            if (userInformation?.is_fixed_term)
            {
              panel=<>Your subscription is pre-paid so you cannot change the payment details</>
            }
            else if (userInformation?.status!=SubscriptionStatus.active)
            {
              panel=<>You do not have an active subscription.</>
            }
            else if (paymentInformation)
            {
              if (paymentInformation.processor==ProcessorType.stripe)
              {
                panel=<>Please click <Link href='#' onClick={async(e: React.MouseEvent<HTMLElement>) => await changePaymentMethod(e)}>here</Link> to change your credit card details</>
              }
              else
              {
                panel=<>Your subscription is with <a href="https://www.paypal.com">PayPal</a>, so please log on there to change your payment details.</>
              }
          }
            break;
      }

      async function upgradeMe()
      {
        let at =  await fetch('/n/api/upgradesubscription', {
          method: 'POST',         
          headers: {
            'Content-Type': 'application/json',
          },
          credentials:"include",
          body: JSON.stringify(
            {subscriptionLevel: upgradeForm.values.upgradeOption, 
            currencyCode: localizationInformation?.CurrencyCode,
            cancelUrl: window.location.href,
            userName: userInformation?.userName
          
          })
        });        
        let k = await at.json();
      
        if (k.status!='OK')
        {
          throw new WPError(k.message);
        }
        
        if (k.link)
        {
            router.push(k.link);
            return true;
        }
        else
        {
          setUpgraded(true);
          return false;
        }

      }

      async function cancelMe()
      {
        let at =  await fetch('/n/api/cancelsubscription', {
          method: 'POST',       
          credentials:"include",  
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({cancellationReason: cancellationForm.values.cancellationReason})
        });        
        let k = await at.json();
      
        if (k.status!='OK')
        {
          throw new WPError(k.message);
        }
        
      }

      async function fetchPaymentInformation()
      {

        if (!userInformation?.is_fixed_term)
        {
        
          let a = await fetch("/n/api/getpayments", {
            method: 'GET',  cache: "no-store" as RequestCache, credentials:"include" as RequestCredentials
        });

        if (a.ok)
        {
          let j = await a.json();
          setPayments(j.payments);
          setPaymentInformation(j.paymentInformation);
        }
      }

      }

      async function fetchAvatar()
      {
        let a = await fetch(`${process.env.NEXT_PUBLIC_ELTON_ROUTE}/users/${userInformation?.user_id}`, {
          method: 'GET',  cache: "no-store" as RequestCache, credentials:"include" as RequestCredentials
      });

      if (a.ok)
      {
        let j = await a.json();
        setAvatarGuid(j.avatarGuid);
      }
      }

      async function fetchUpgradeOptions()
      {
          let a = await fetch("/n/api/caniupgrade", {
            method: 'GET',  cache: "no-store" as RequestCache, credentials:"include" as RequestCredentials
        });

        if (a.ok)
        {
          let j = await a.json();
          setCanIUpgrade(j.canUpgrade);
        }

      }

      async function menuClicked(i: MenuItems)
      {
        setActiveMenu(i);

        switch (i)
        {
          case MenuItems.paymentHistory:
          case MenuItems.changePaymentMethod:
            if (!payments)
            {
              await fetchPaymentInformation();
            }
          break;
        case MenuItems.upgradeAccount:
          if (canIUpgrade == null)
          {
            await fetchUpgradeOptions();
          }
          break;


        }

      }


    return (
        <Layout menuId={MenuId.account}>
            <Head>
                <title>My account</title>
                <meta name="robots" content="noindex"/>
            </Head>
        
            <AuthContent>
              <ImageUpload circleOverlay square ref={uploadRef} showTitle={false} postRoute={process.env.NEXT_PUBLIC_ELTON_ROUTE + `/users/avatars/upload`} onUploaded={avatarUploaded}/>
            <div className = {styles.mainContent}>
            <Paper shadow="md" radius="md" p="sm" withBorder style={{position:"relative", minWidth:"200px", marginLeft:"auto", marginRight:"auto"}}>
    <LoadingOverlay visible={working} overlayProps={{ blur: 2 }} />
            <h1>My account</h1>
            <div className = {styles.topLine}>
                <div className = {styles.subscriptionInformation}>
                <AccountDescription/>
                </div>
                </div>
     
                <Center><Divider my="lg" style={{maxWidth:400, minWidth:400}}  /></Center>
                <Center><Text fw='bold'>Use the options on the left to <a href='#' onClick={(e)=>{e.preventDefault(); upgradeAccount();}}>upgrade</a> or <a href='#' onClick={(e)=>{e.preventDefault(); cancelAccount();}}>cancel</a> your account, and more.</Text></Center>

                <Center><Divider my="lg" style={{maxWidth:400, minWidth:400}}  /></Center>
                
      
      <Grid>

      <Grid.Col span="content">
     <Box>
       {Object.values(MenuItems).map(x=><NavLink key={x} label={x} active={activeMenu==x} onClick={() => menuClicked(x)}/>)}
      </Box>
      </Grid.Col>
      <Grid.Col span="auto" style={{ marginLeft: 'var(--mantine-spacing-lg)' }}>
        {panel}
         </Grid.Col>
         </Grid>
</Paper>
</div>

            </AuthContent>
        </Layout>
    )
}

function EmailCodeForm({ onSubmit, email }: { onSubmit: (code: string) => Promise<void>; email: string }) {
  const [otpValue, setOtpValue] = useState('');

  async function handleOTP()
  {
    if (otpValue.length!=6)
    {
      okModal("Please enter the 6 digit code we emailed you.");
      return;
    }
    await onSubmit(otpValue);
  }

  return (
  
      <Stack>
        <Text size="sm">We sent a verification code to <strong>{email}</strong></Text>

         <Center>
                  <FocusTrap active>
                  <PinInput
                    length={6}
                    type="number"
                    oneTimeCode
                    value={otpValue}
                    onChange={setOtpValue}
                    onComplete={async() => await handleOTP()}
                  />
                  </FocusTrap>
                </Center>
        

        <Button type="submit" onClick={async()=>await handleOTP()}>Verify</Button>
      </Stack>
 
  );
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { userId } = getAuth(ctx.req)
  return { props: { ...buildClerkProps(ctx.req) } }
}


